<script>
export default {
  name: 'ColorSpectrumPicker',
  data() {
    return {
      selected: this.setting.idx
    }
  },
  methods: {
    format_gradient_id(str) {
      return `${this.component_id}-${str.toLowerCase().replace(/ /g, '-')}-gradient`
    },
    on_change() {
      this.$emit('change', this.selected)
    }
  },
  props: {
    component_id: {type: String, default: () => ''},
    setting: {type: Object, default: () => Object()}
  }
}
</script>

<template>
<v-list flat class='flex-grow-1'>
  <v-list-item-group v-model='selected' @change='on_change'
    :multiple='false' :mandatory='true'>
    <template v-for='(option, i) in setting.options'>
      <v-list-item :key='option.label' :value='i'
        active-class='active-class' :ripple='false'>
        <template v-slot:default='{active, toggle}'>
          <v-list-item-action class='mr-3 pt-6 pb-0'>
            <v-checkbox :input-value='active' :true-value='selected' @click='toggle'/>
          </v-list-item-action>
          <v-list-item-content class='pr-2'>
            <v-list-item-title v-html='option.display_name' class='pa-0'/>
            <svg class='mt-1' width='100%' height='21'>
              <defs>
                <linearGradient :id='format_gradient_id(option.display_name)'>
                  <stop v-for='i in 32'
                    :key='`${format_gradient_id(option.display_name)}-stop-${i}`'
                    :offset='(i-1)/31' :stop-color='option((i-1)/31)'/>
                </linearGradient>
              </defs>
              <rect width='100%' height='100%'
                :fill='`url(#${format_gradient_id(option.display_name)})`'/>
            </svg>
          </v-list-item-content>
        </template>
      </v-list-item>
    </template>
  </v-list-item-group>
</v-list>
</template>

<style lang='sass' scoped>
::v-deep .v-list-item
  padding: 0

.theme--light
  .active-class
    background-color: white
</style>
